export enum FundRequestExpenseTypes {
    DEFAULT = 'Default',
    TRAVEL = 'Travel',
    FOOD = 'Food',
}
export const fundRequestExpenseTypesList: string[] = Object.values(
    FundRequestExpenseTypes
);

export enum FoodExpenseClientTypes {
    CLIENT = 'client',
    CAREGIVER = 'caregiver',
    BOTH = 'both',
}

export const foodExpenseClientTypesList: string[] = Object.values(
    FoodExpenseClientTypes
);

export enum FundRequestStatus {
    OPEN = 'open',
    IN_REVIEW = 'in_review',
    NEEDS_INFO = 'needs_info',
    AP_REVIEW = 'ap_review',
    FOR_DOF_APPROVAL = 'for_dof_approval',
    APPEALED = 'appealed',
    REJECTED = 'rejected',
    PAID = 'paid',
    PENDING = 'pending',
}
